import { isTimeSeriesData, NoticeKind, TimeSeriesData } from '@/core';
import { getData } from './get-data';

/**
 * Temporary flag to disable the duplicate series name notice
 * TODO: leverage editable-edit metadata to scope the notice to edit mode
 */
const DISABLE_DUPLICATE_SERIES_NOTICE = true;

export const addDuplicateSeriesNameNoticeWrapper: (getDataFn: typeof getData) => NonNullable<typeof getData> = (
  getDataFn
) => {
  return async (spec, ctx, additionalHeaders = {}, fetchFn) => {
    const result = await getDataFn(spec, ctx, additionalHeaders, fetchFn);
    if (!DISABLE_DUPLICATE_SERIES_NOTICE && !spec.disable_duplicate_series_notice && isTimeSeriesData(result.data)) {
      addDuplicateSeriesNameNotice(result.data);
    }
    return result;
  };
};

export function addDuplicateSeriesNameNotice(chartData: TimeSeriesData) {
  const seriesNames: Set<string> = new Set<string>();
  let hasDuplicateFormattedSeriesNames = false;

  for (const series of chartData.series) {
    const name = series.formattedName || series.name;
    if (seriesNames.has(name)) {
      hasDuplicateFormattedSeriesNames = true;
    }
    seriesNames.add(name);
  }

  if (hasDuplicateFormattedSeriesNames) {
    chartData.metadata?.notices?.push({
      type: 'warning',
      kind: NoticeKind.DuplicateFormattedSeriesName,
      message: 'Duplicate series names have been detected.',
      description: 'Consider changing the "Series naming" configuration for this panel.',
    });
  }
}
